var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-navigation-drawer',{staticClass:"color",style:(_vm.style),attrs:{"app":"","clipped":"","flat":"","mobile-breakpoint":"xs","width":_vm.width,"hide-overlay":""},model:{value:(_vm.drawerOpen),callback:function ($$v) {_vm.drawerOpen=$$v},expression:"drawerOpen"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }